var map = {
	"./authorityConfig.json": 41124,
	"./iso639toBCP47.json": 77699,
	"./literalDataType.json": 26992,
	"./literalPropertyAttribute.json": 69547,
	"./propertyAttribute.json": 88684,
	"./propertyType.json": 30388,
	"./resourceAttribute.json": 73691,
	"./searchConfig.json": 84735,
	"./specialcharacters.json": 70992,
	"./templates/rt_literal_property_attrs_doc.json": 31623,
	"./templates/rt_lookup_property_attrs_doc.json": 51308,
	"./templates/rt_property_template_doc.json": 53949,
	"./templates/rt_resource_property_attrs_doc.json": 45378,
	"./templates/rt_resource_template_doc.json": 10938,
	"./templates/rt_uri_property_attrs_doc.json": 2448,
	"./uriAttribute.json": 21363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35170;